import type { NostrEvent } from '@nostrify/nostrify';

/** Build the addressable coordinate ("30023:pubkey:d") for an article event. */
export function articleCoordinate(event: NostrEvent): string {
  const d = event.tags.find(([n]) => n === 'd')?.[1] ?? '';
  return `${event.kind}:${event.pubkey}:${d}`;
}

/** Format a unix timestamp (seconds) as a readable date. */
export function formatDate(unixSeconds: number): string {
  return new Date(unixSeconds * 1000).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

/** Rough reading-time estimate in minutes from markdown content. */
export function readingTime(markdown: string): number {
  const words = markdown.trim().split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.round(words / 220));
}
